// extracted by mini-css-extract-plugin
export default {"button":"Button_button__EXN0a","buttonInverse":"Button_buttonInverse__At8aY"};